import { jsxs as d, jsx as C } from "react/jsx-runtime";
const r = ({
  width: l,
  height: e,
  className: o
}) => /* @__PURE__ */ d(
  "svg",
  {
    className: o,
    fill: "none",
    height: e,
    viewBox: "0 0 14 12",
    width: l,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          clipRule: "evenodd",
          d: "M13.0667 8.6761V10.0765C13.0667 10.489 12.9023 10.8611 12.637 11.1326C12.3743 11.4015 12.0081 11.5702 11.605 11.5702H1.45908C1.05859 11.5702 0.692409 11.402 0.429683 11.1326C0.164396 10.8611 0 10.489 0 10.0765V8.6761H0.00256069C0.0199733 8.30136 0.324183 8 0.695482 8C1.06422 8 1.36843 8.30189 1.38584 8.6761H1.3884V9.21907V9.1436V9.75471V9.81236C1.3884 9.99842 1.5359 10.1515 1.71771 10.1515H11.35C11.5318 10.1515 11.6793 9.99842 11.6793 9.81236V9.75471V9.1436V9.21907V8.6761H11.6818C11.6987 8.30136 12.0035 8 12.3722 8C12.743 8 13.0477 8.30189 13.0651 8.6761H13.0677H13.0667Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.53228 0C6.91536 0 7.22776 0.319181 7.22776 0.709116V5.73739C7.22776 6.12681 6.91587 6.44651 6.53228 6.44651C6.15176 6.44651 5.83936 6.12733 5.83936 5.73739V0.709116C5.83936 0.319181 6.15125 0 6.53228 0Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          clipRule: "evenodd",
          d: "M9.67424 3.86636C9.94465 4.14309 9.94465 4.59539 9.67424 4.8695C8.79746 5.76677 7.91761 6.66719 7.04083 7.56446C7.03571 7.5697 7.0311 7.57703 7.02342 7.58228C6.89333 7.7154 6.72126 7.78615 6.54918 7.78825C6.54406 7.78825 6.53945 7.78825 6.53432 7.79087H6.53176C6.52664 7.78825 6.52203 7.78825 6.51691 7.78825C6.34483 7.78563 6.17276 7.7154 6.04267 7.58228C6.0355 7.57703 6.03038 7.5697 6.02577 7.56446C5.14643 6.66719 4.26914 5.76677 3.39236 4.8695C3.12247 4.59539 3.12247 4.14309 3.39236 3.86636C3.66277 3.58963 4.10475 3.58963 4.37259 3.86636C5.09266 4.60273 5.81221 5.33962 6.53228 6.07599C7.25439 5.33962 7.97445 4.60273 8.69401 3.86636C8.96185 3.58963 9.40383 3.58963 9.67424 3.86636Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      )
    ]
  }
);
export {
  r as Content
};
